'use client';
import _extends from "@babel/runtime/helpers/esm/extends";
import React, { forwardRef } from 'react';
export var ArrowRight = /*#__PURE__*/forwardRef(function ArrowRight(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 16 16",
    fill: "currentColor",
    ref: ref
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "m6 12 4-4-4-4z"
  }));
});